import React, { useEffect } from 'react'; 
import { deleteTodo, getAllTodos } from '../redux/actions/index';
import { useDispatch, useSelector } from 'react-redux';
import { ALL_TODOS, ACTIVE_TODOS, DONE_TODOS } from '../redux/actions/type';
//component
import Todo from './Todo';
import Tabs from './Tabs';


//call api here to fetch all todos from backend to the frontend
export const Todos = () => {

    const dispatch = useDispatch();
    //fetches all the todos data from redux
    const todos = useSelector(state => state.todos);  //useselector fetches data from redux
    const currentTab = useSelector(state => state.currentTab); //current tab konta selected ota pacchi

    useEffect(() => {
        dispatch(getAllTodos());
    },[])

    const getTodos = () => {
        if (currentTab === ALL_TODOS ){
            return todos;
        }
        else if(currentTab === ACTIVE_TODOS){
            return todos.filter(todo => !todo.done) //todo.done false  hote hobe means db e done false jegula ogula show korbe just
        }
        else if(currentTab === DONE_TODOS){
            return todos.filter(todo => todo.done)
        }
    }

    const removeDoneTodos = () => {
        todos.forEach(({ done, _id }) => {
            if(done) {
                dispatch(deleteTodo(_id));
            }
        })
    }
    return (
        <article>
            <div>
                <Tabs currentTab={currentTab}/>

                {
                    todos.some(todo => todo.done) ? (
                        <button
                            onClick={removeDoneTodos}
                            className="button clear"
                        >Remove Done Todos</button>
                    ) : null
                } 
            </div>
            <ul>
                {
                    getTodos().map(todo => (
                        <Todo
                            key={todo._id}
                            todo={todo}
                         />

                    ))
                }
            </ul>
        </article>
    )
}

export default Todos;